import React from "react";
import { iconProps } from "../../Helper";

const ImageToVideoIcon = ({className}:iconProps) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_13038_284"
        style={{maskType:"alpha"}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="16"
      >
        <rect x="0.5" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_13038_284)">
        <path
        className={className}
          d="M4.2115 10.5768H10.4423L8.37316 7.859L6.7885 9.88467L5.74233 8.58983L4.2115 10.5768ZM3.532 13C3.19533 13 2.91033 12.8833 2.677 12.65C2.44366 12.4167 2.327 12.1316 2.327 11.7948V4.20517C2.327 3.86839 2.44366 3.58333 2.677 3.35C2.91033 3.11667 3.19533 3 3.532 3H11.1218C11.4585 3 11.7435 3.11667 11.9768 3.35C12.2102 3.58333 12.3268 3.86839 12.3268 4.20517V7.2565L14.673 4.91033V11.0897L12.3268 8.7435V11.7948C12.3268 12.1316 12.2102 12.4167 11.9768 12.65C11.7435 12.8833 11.4585 13 11.1218 13H3.532ZM3.532 12H11.1218C11.1816 12 11.2307 11.9808 11.2692 11.9423C11.3077 11.9039 11.327 11.8547 11.327 11.7948V4.20517C11.327 4.14528 11.3077 4.09611 11.2692 4.05767C11.2307 4.01922 11.1816 4 11.1218 4H3.532C3.47222 4 3.42311 4.01922 3.38466 4.05767C3.34622 4.09611 3.327 4.14528 3.327 4.20517V11.7948C3.327 11.8547 3.34622 11.9039 3.38466 11.9423C3.42311 11.9808 3.47222 12 3.532 12Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default ImageToVideoIcon;
